"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColorScheme = void 0;
var use_media_query_1 = require("../use-media-query/use-media-query");
function useColorScheme() {
    return use_media_query_1.useMediaQuery('(prefers-color-scheme: dark)') ? 'dark' : 'light';
}
exports.useColorScheme = useColorScheme;
